<template>
  <div class="caseDetail">
    <heads></heads>
    <div class="container"  v-if="!loading">
      <div class="container-top">
        <div class="swiper-wrapper">
          <!-- 轮播图 -->
          <swiper
            v-if="detailResult.image && detailResult.image.length > 0"
            :options="swiperOptionTop"
            class="gallery-top"
            ref="swiperTop"
          >
            <swiper-slide
              class="slide-1"
              v-for="(item, index) in detailResult.image"
              :key="index"
            >
              <div class="swiper-content">
                <img
                  :src="item"
                  alt
                />
              </div>
            </swiper-slide>
          </swiper>
          <div
            class="swiper-button-next swiper-button-gray"
            slot="button-next"
          ></div>
          <div
            class="swiper-button-prev swiper-button-gray"
            slot="button-prev"
          ></div>
        </div>
      </div>
      <div class="container-bottom" ref="containerBottomRef">
        <div class="article">
          <div class="company-icon">
            <img :src="detailResult.companyImage" alt />
          </div>
          <div class="flow">
            团建案例 {{ detailResult.caseDate ? detailResult.caseDate : "-" }} |
            浏览
            {{
              typeof detailResult.visits == "number" ? detailResult.visits : "-"
            }}
          </div>
          <div class="title">{{ detailResult.title }}</div>
          <div class="subtitle">
            {{ detailResult.subtitle }}
          </div>
          <div class="tag">
            <span>{{ detailResult.caseTypeName }}</span>
          </div>
          <div class="article-content">
            <!--文章 -->
            <div
              class="article-content-item"
              v-for="(item, index) in detailResult.lxqCasePictureList"
              :key="index"
            >
              <video
                v-if="item.video"
                controls="controls"
                :src="item.video"
              ></video>
              <p class="">{{ item.description }}</p>
              <img
                v-for="(item, index) in item.image"
                :key="index"
                :src="item"
              />
            </div>
          </div>
          <div class="article-summary">
            <span>蓝星球活动总结</span>
            <p>
              {{ detailResult.summary }}
            </p>
          </div>
        </div>
        <div class="case-information" ref="caseInformationRef">
          <div class="large-title">
            活动概述
            <div class="long-line1"></div>
          </div>
          <div class="activity-overview">
            <div class="activity-overview-item">
              <i class="el-icon-s-custom"></i>
              <div>
                <span class="title">人数: </span>
                <span class="content"
                  >{{ detailResult.number ? detailResult.number : "-" }}人</span
                >
              </div>
            </div>
            <div class="activity-overview-item">
              <i class="el-icon-date"></i>
              <div>
                <span class="title">天数: </span>
                <span class="content"
                  >{{ detailResult.day ? detailResult.day : "-" }}天{{
                    detailResult.night ? detailResult.night : "-"
                  }}晚</span
                >
              </div>
            </div>
            <div class="activity-overview-item">
              <i class="el-icon-truck"></i>
              <div>
                <span class="title">车程: </span>
                <span class="content">{{
                  detailResult.drive ? detailResult.drive : "-"
                }}</span>
              </div>
            </div>
            <div class="activity-overview-item">
              <i class="el-icon-location-outline"></i>
              <div>
                <span class="title">地点: </span>
                <span class="content">{{
                  detailResult.place ? detailResult.place : "-"
                }}</span>
              </div>
            </div>
          </div>
          <div class="large-title" v-if="detailResult.scheduleVoList&&detailResult.scheduleVoList.length>0">
            案例行程
            <div class="long-line2"></div>
          </div>

          <div class="case-schedule" v-if="detailResult.scheduleVoList&&detailResult.scheduleVoList.length>0">
            <el-timeline
              v-for="item in detailResult.scheduleVoList"
              :key="item.id"
            >
              <el-timeline-item 
                placement="top"
                class="tour-header"
              >
                <div class="tour-header-item">
                  <div class="icon">
                    <span class="day">D{{ item.mumber }}</span>
                  </div>
                </div>
              </el-timeline-item>
              <el-timeline-item  v-for="item in item.scheduleDetailVoList"
                        :color="activity.color"
                        :key="item.id" class="tour-body-item" :timestamp="item.scheduleTime" placement="top">
                <div>{{item.title}}<span class="time">{{timeConverter(item.spendTime)}}</span></div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div
            class="large-title"
            ref="relatedProductsTitleRef"
            v-if="detailResult.type && dataForm.title"
          >
            相关产品
            <div class="long-line3"></div>
          </div>
          <div
            class="related-products"
            ref="relatedProductsRef"
            :class="[
              relatedProductStyle == 1
                ? 'related-products1'
                : 'related-products2',
              detailResult.type ? '' : 'hide',
            ]"
            :style="relatedProductStyle == 2 ? { top: topHeight } : ''"
          >
            <div class="related-product-content" @click="gotoProduct(detailResult.type,dataForm.id)">
              <img :src="dataForm.image" />
              <div class="title">{{ dataForm.title }}</div>
              <div class="tags">
                <div class="tag-left">
                  {{ dataForm.day ? dataForm.day : "-" }}天{{
                    dataForm.night ? dataForm.night : "-"
                  }}晚 | {{ dataForm.numberMin ? dataForm.numberMin : "0" }}-{{
                    dataForm.numberMax ? dataForm.numberMax : "不限"
                  }}人
                </div>
                <div class="tag-right">
                  <span>{{ dataForm.price ? dataForm.price : "-" }}</span>
                </div>
              </div>
              <div class="submit-button">
                <div @click.stop="requireDialogVisible = true">定制团建方案</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading-page" v-if="loading"  v-loading="loading">
      <!-- <el-empty description="加载中"></el-empty> -->
    </div>
    <el-dialog :visible.sync="requireDialogVisible" width="0%">
      <rquirementsForm
        :dialogVisible="requireDialogVisible"
        :dataForm="dataForm"
        v-on:getRequireDialogVisible="closeRequireDialogVisible"
      ></rquirementsForm>
    </el-dialog>
   <quickContact :message="quickContactMessage"></quickContact>
    <homeFoots></homeFoots>
  </div>
</template>
<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import rquirementsForm from "../comment/rquirementsForm.vue";
import quickContact from "@/components/comment/quickContact.vue";
import { handlePicPlusPre, handleVideo,timeConverter } from "@/util/util.js";
import axios from "axios";
import { Swiper, SwiperSlide, } from "vue-awesome-swiper";
import wxShare from "@/common/wx_share.js";
export default {
  name: "caseDetail",
  data() {
    return {
      id: 0,
      loading: false,
      // 高度计算参数
      relatedProductStyle: 3,
      topHeight: "0px",
      dataForm: {},
      detailResult: {},
      requireDialogVisible: false,
      activity: {
        size: "large",
        type: "primary",
        icon: "el-icon-eleme",
        color: "#359ff888",
      },
      height: 0,
      activityIndex: 0,
      swiperLoading: false,
      swiperOptionTop: {
        autoplay: true,
        loop: true,
        slidesPerView: "auto",
        spaceBetween: 1,
        centeredSlides: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        swiperLoading: false,
        on: {
          init() {
            this.setTranslate(0);
          },
          transitionStart() {
            // 开始translate之前触发
            // 如果是第一张
            if (this.activeIndex == 0) {
              this.setTranslate(0); // 因为左边会空出一张图的距离，所以设置位移为0
            }
          },
        },
      },
      quickContactMessage:{
        type:1
      },
    };
  },
  components: {
    heads,
    homeFoots,
    // Swiper,
    // SwiperSlide,
    rquirementsForm,
    quickContact,
    handlePicPlusPre,
    
  },
  computed: {},
  methods: {
    // fomateDate,
    handleVideo,
    timeConverter,
    // 去相关产品页面
    gotoProduct(type,productId){
      if(type==1){
        window.open("/#/teamBuildingDetail?id="+productId)
      }else if(type == 2){
        window.open("/#/annualMeetingDetail?id="+productId)   
      }
    },
    submit() {},
    closeRequireDialogVisible(val) {
      this.requireDialogVisible = val;
    },
    getCaseDetail() {
      this.loading = true;
      axios.get(`/api/case/` + this.id).then((res) => {
        if (res.data && res.data.code == 200) {
          this.detailResult = res.data.data;
          if (this.detailResult.image) {
            this.detailResult.image = handlePicPlusPre(this.detailResult.image);
            console.log(this.detailResult.image)
          }
          if (this.detailResult.type) {
            if (this.detailResult.type == 1 && this.detailResult.lxqTb) {
              let {
                id,
                image,
                title,
                day,
                night,
                price,
                avgPrice,
                numberMax,
                numberMin,
              } = this.detailResult.lxqTb;
              this.dataForm = {
                id,
                image,
                title,
                day,
                night,
                price,
                avgPrice,
                numberMax,
                numberMin,
              };
            } else if (
              this.detailResult.type == 2 &&
              this.detailResult.lxqMeeting
            ) {
              let {
                id,
                image,
                title,
                day,
                night,
                price,
                avgPrice,
                numberMax,
                numberMin,
              } = this.detailResult.lxqMeeting;
              this.dataForm = {
                id,
                image,
                title,
                day,
                night,
                price,
                avgPrice,
                numberMax,
                numberMin,
              };
            }
          }
          if (this.dataForm.image) {
            this.dataForm.image = handlePicPlusPre(this.dataForm.image);
            this.dataForm.image = this.dataForm.image[0];
          }
          if (this.detailResult.title) {
              document.title = this.detailResult.title;
          }
          // 个人图像图片
          if (this.detailResult.plannerIcon) {
            this.detailResult.plannerIcon = handlePicPlusPre(
              this.detailResult.plannerIcon
            );
            this.detailResult.plannerIcon = this.detailResult.plannerIcon[0];
          }
          // 公司图片
          if (this.detailResult.companyImage) {
            this.detailResult.companyImage = handlePicPlusPre(
              this.detailResult.companyImage
            );
            this.detailResult.companyImage = this.detailResult.companyImage[0];
          }
          //案例图片
          if (this.detailResult.lxqCasePictureList) {
            this.detailResult.lxqCasePictureList.forEach((casePicture) => {
              // 视频
              if (casePicture.video) {
                console.log(casePicture.video)
                casePicture.video = handleVideo(casePicture.video);
              }
              if (casePicture.image) {
                casePicture.image = handlePicPlusPre(casePicture.image);
              }
            });
          }

          // 行程图片
          if (this.detailResult.scheduleList) {
            this.detailResult.scheduleList.forEach((schedule) => {
              if (schedule.scheduleDetailVoList) {
                schedule.scheduleDetailVoList.forEach((detail) => {
                  if (detail.scheduleTypeImage) {
                    detail.scheduleTypeImage = handlePicPlusPre(
                      detail.scheduleTypeImage
                    )[0];
                  }
                });
              }
            });
          }
          this.loading = false;
          if (wxShare.is_wx()) {
              wxShare.wxReWriteShare(
                `${this.detailResult.title}`,
                `${this.detailResult.subtitle}`,
                `${window.location.href}`,
                `${
                  this.detailResult.image && this.detailResult.image.length > 0
                    ? this.detailResult.image[0]
                    : this.$store.state.defaultPic
                }`
              );
          }
        }
      }).catch (e=>{
        this.loading = true;
      });
    },
    // 计算免费定制的显示
    handleScrollx() {
      let containerBottomBottom =
        this.$refs.containerBottomRef.getBoundingClientRect().bottom;
      let containerBottomTop =
        this.$refs.containerBottomRef.getBoundingClientRect().top;
      let caseInformationHeight = this.$refs.caseInformationRef.offsetHeight;
      let relatedProductsHeight = this.$refs.relatedProductsRef.offsetHeight;
      let condition1 = containerBottomTop + caseInformationHeight;
      console.log(condition1);
      console.log(caseInformationHeight);
      console.log(containerBottomBottom - relatedProductsHeight - 60);
      if (
        condition1 <= 0 &&
        containerBottomBottom - relatedProductsHeight - 100 >= 0
      ) {
        this.relatedProductStyle = 1;
        return;
      } else {
        if (condition1 >= 0) {
          this.relatedProductStyle = 3;
        } else {
          this.relatedProductStyle = 2;
        }
      }
      // // 计算触底位置
      console.log(condition1);
      console.log(containerBottomBottom);
      // 默认计算触顶位置
      this.topHeight = "";

      // // 计算触底位置
      console.log(relatedProductsHeight);
      // // 数据大于3条才会触发
      if (containerBottomBottom - relatedProductsHeight - 100 < 0) {
        let containerBottomRef = this.$refs.containerBottomRef.offsetHeight;
        this.topHeight =
          containerBottomRef - relatedProductsHeight - 100 + "px";
      }
    },
    initSwiper() {
      const _this = this;
      new Swiper(".swiper-wrapper", {
        swiperOptionTop: this.swiperOptionTop,
      });
    },
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getCaseDetail();
    this.$nextTick(() => {
      this.initSwiper();
    });
    window.addEventListener("scroll", this.handleScrollx, true);
    // 微信分享
    if (wxShare.is_wx()) {
      wxShare.wxReWriteShare(
        `${this.$store.state.defaultTitle}`,
        `${this.$store.state.defaultDesc}`,
        `${window.location.href}`,
        `${this.$store.state.defaultPic}`
      );
    }
  },
  created() {},
  destroyed() {
    window.removeEventListener("scroll", this.handleScrollx, true);
  },
};
</script>
<style scoped>
.container {
  width: 100%;
}
.container-top {
  height: 430px;
  margin-top: 0px;
}
.container-top .swiper-content {
  /* height: 430px; */
}
.container-top .swiper-slide-active {
  /* z-index: 10;
  position: relative;
  left: -30px; */
  /* margin: 0px 100px; */
}
.swiper-wrapper {
  min-width: 600px;
  width: 100%;
}
.swiper-wrapper .swiper-container {
  /* display: flex;
  flex-direction: row;
  justify-content: center;
  background-color: #fff; */
}

.swiper-wrapper .swiper-content img {
  height: 100%;
  width: 100%;
  margin: 0;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
}
.swiper-wrapper .swiper-slide {
  width: 632px !important;
  height: 430px;
}
/* .swiper-wrapper .swiper-slide-prev{
  position: relative;
  left:-215px;
}
.swiper-wrapper .swiper-slide-active{
  position: relative;
  left:-90px;
}
.swiper-wrapper .swiper-slide-next{
  position: relative;
  left:35px;
} */
.swiper-wrapper .swiper-content {
  width: 632px;
  height: 430px;
  margin: 0px !important;
}
/*swiper*/
.swiper-wrapper .swiper-button-gray {
  z-index: 1000;
  transition: all 0.2s ease-in-out;
  opacity: 0;
  color: #fff7;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 30px;
}
.swiper-wrapper:hover .swiper-button-gray {
  z-index: 1000;
  transition: all 0.2s ease-in-out;
  opacity: 1;
  color: #fff7;
  font-size: 14px;
  position: absolute;
  width: 60px;
  height: 60px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 30px;
}
/* .gallery-top {
  height: 100% !important;
  width: 100%;
}
.gallery-top .slide-1{
  background-position: center center;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.gallery-top .slide-1  a {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
.gallery-thumbs {
  position: absolute;
  right: 50px;
  top: 150px;
  width: 100px;
  height: 190px;
  padding: 0 5px;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
} */
/* 下方布局 */
.container-bottom {
  display: flex;
  flex-direction: row;
  position: relative;
  min-height: 1000px;
  width: 1060px;
  margin: 0 auto;
}

/* 左边 */
.container-bottom .article {
  display: flex;
  flex-direction: column;
  width: 660px;
  background-color: #fff;
  position: relative;
  text-align: left;
}
.container-bottom .article .company-icon {
  position: absolute;
  height: 140px;
  left: 0;
  top: -84px;
  background: #fff;
  box-shadow: 0 2px 20px 0 rgb(0 0 0 / 10%);
  z-index: 1000;
}
.article .company-icon img {
  background-size: cover;
  height: 140px;
  background-repeat: no-repeat;
}
.article .flow {
  font-size: 14px;
  color: #999;
  padding-top: 42px;
  text-align: right;
}
.article .title {
  font-weight: 700;
  font-size: 36px;
  color: #222;
  line-height: 80px;
  border-bottom: 1px solid #ececec;
}
.article .subtitle {
  padding: 30px 0 10px 0px;
  font-weight: 700;
  font-size: 16px;
  color: #222;
  text-align: justify;
  line-height: 28px;
}
.article .tag {
  display: flex;
  flex-direction: row;
}
.article .tag span {
  background: #fff;
  border: 1px solid #e8e8e8;
  height: 16px;
  line-height: 16px;
  border-radius: 13px;
  padding: 0 10px;
  font-size: 12px;
  color: #999;
  margin-right: 10px;
}
.article .article-content {
}
.article .article-content video {
  width: 325px;
  height: 217px;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  margin-top: 30px;
}
.article-content-item {
}
.article-content-item p {
  font-size: 14px;
  color: #222;
  text-align: justify;
  line-height: 24px;
  padding: 16px 0;
}
.article-content-item img {
  width: 100%;
  display: block;
  margin-bottom: 8px;
}
.article-summary {
  padding: 10px;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 10px 20px;
  margin-top: 20px;
  margin-bottom: 40px;
}
.article-summary span {
  font-size: 16px;
  font-weight: 700;
  color: #999;
  display: block;
  text-align: left;
  line-height: 40px;
  height: 40px;
}
.article-summary p {
  font-size: 14px;
  color: #999;
  text-align: justify;
  line-height: 24px;
}
/* 右边 */
.container-bottom .case-information {
  position: absolute;
  width: 360px;
  top: 40px;
  right: 0;
}
.case-information .large-title {
  font-size: 20px;
  color: #222;
  display: block;
  font-weight: 700;
  text-align: left;
  position: relative;
}
.case-information .long-line1 {
  border-bottom: 1px solid #ececec;
  position: absolute;
  left: 90px;
  top: 12px;
  right: 0;
}
.case-information .long-line2 {
  border-bottom: 1px solid #ececec;
  position: absolute;
  left: 90px;
  top: 12px;
  right: 0;
}
.case-information .long-line3 {
  border-bottom: 1px solid #ececec;
  position: absolute;
  left: 90px;
  top: 12px;
  right: 0;
}
.case-information > div {
  margin-bottom: 20px;
}
.case-information .activity-overview {
  display: flex;
  flex-direction: row;
  width: 360px;
  flex-wrap: wrap;
}
.case-information .activity-overview-item {
  width: 45%;
  height: 30px;
  line-height: 30px;
  text-align: left;
  padding-left: 10px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
.case-information .activity-overview-item > div {
  padding-left: 10px;
}
.case-information .activity-overview-item .title {
  font-size: 16px;
  color: #222;
  line-height: 30px;
  height: 30px;
}
.case-information .activity-overview-item .content {
  /* font-size: 18px;
    color: #212121;
    line-height: 30px;
    height: 30px; */
  padding-left: 5px;
}
.case-information .case-schedule {
}
.case-information .case-schedule .tour-header {
}
.tour-header-item {
  position: relative;
  top: -19px;
  left: 0px;
}
.tour-header-item >>> .el-timeline-item__timestamp,
.tour-itinerary-item >>> .el-timeline-item__timestamp {
  color: #0000 !important;
}
.tour-header-item .tour-header-left {
  margin-right: 10px;
  padding-left: 0px;
  display: inline;
}
.case-information .case-schedule >>> .el-timeline-item__timestamp {
  position: absolute;
  left: -50px;
}
.case-information .case-schedule .tour-header-item>>> .el-timeline-item__content > div {
  position: absolute;
  left: 30px;
  font-size: 14px;
  color: #222;
}
.case-information .case-schedule .tour-body-item>>> .el-timeline-item__content > div {
  position: absolute;
  left: 30px;
  font-size: 14px;
  color: #222;
}
.tour-header-item .icon {
  display: inline;
  position: absolute;
  left: -38px;
  top: 5px;
  width: 30px;
  height: 30px;
  background: #359ff8;
  border-radius: 50% 50% 50% 4%;
  transform: rotate(-45deg);
  color: #fff;
}
.tour-header-item .icon .day {
  transform: rotate(45deg);
  display: inline-block;
  position: relative;
  left: -1px;
  top: 8px;
  color: #fff;
}
.case-information .case-schedule >>> .el-timeline-item__content > div .time {
  /* position: absolute;
  left: 30px; */
  font-size: 14px;
  padding-left: 10px;
  color: #359ff8;
}
.case-information .case-schedule >>> .el-timeline {
  position: relative;
  left: 100px;
  margin-top: 20px;
}
.case-information .case-schedule >>> .el-timeline-item {
  padding-bottom: 30px;
}

.case-information .related-products .related-product-content {
  width: 313px;
  cursor: pointer;
}
.case-information .related-products .related-product-content img {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: 50%;
  background-repeat: no-repeat;
  transition: all 0.3s ease-in-out;
}

.related-product-content .title {
  font-size: 18px;
  color: #222;
  text-align: left;
  display: block;
  line-height: 30px;
  font-weight: 700;
  display: block;
  padding: 10px 0;
}
.related-products1 {
  position: fixed;
  top: 80px;
}
.related-products2 {
  position: absolute;
}
.related-product-content .tags {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.related-product-content .tag-left {
  font-size: 14px;
  color: #666;
  line-height: 22px;
}
.related-product-content .tag-right span {
  /* margin-top: -10px; */
  font-weight: 700;
  font-size: 24px;
  color: #f9541c;
}
.related-product-content .tag-right span::after {
  content: "元起/人";
  font-weight: 700;
  font-size: 12px;
  color: #666;
  text-align: left;
  line-height: 28px;
}

.related-product-content .submit-button {
  display: flex;
  flex-direction: row;
  position: relative;
  margin: 20px 0px;
  
}
.submit-button > div {
  width: 320px;
  position: absolute;
  line-height: 50px;
  outline: none;
  background: none;
  border: none;
  height: 50px;
  cursor: pointer;
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  background-color: #222;
  border-radius: 6px;
  text-align: center;
}
p,
span {
  text-align: left;
}
.case-information .case-schedule >>> .el-icon-eleme {
  background: url("../../assets/pic/yellow-ball.png") center no-repeat;
  width: 14px;
}
.case-information .case-schedule >>> .el-icon-eleme:before {
  content: "\8d3a";
  font-size: 14px;
  visibility: hidden;
}
.hide {
  opacity: 0;
}
.loading-page{
  height: 800px;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/case/caseDetail.vue